module.exports = __webpack_public_path__ + "static/media/uos-mono.53fb8f23.svg";